import { InputAdornment } from "@mui/material";
import { TimePicker, ClockIcon } from "@mui/x-date-pickers";
import moment from "moment";
import React, { useRef, useState } from "react";

const TimeSelector = ({
  value,
  name,
  small = true,
  onChange,
  onChangeValue,
  minTime,
  maxTime,
  disabled,
  format = "HH:mm",
}) => {
  const pickerRef = useRef(null);
  const dateValue = moment(value, format);
  const [open, setOpen] = useState(false);

  const onChangeDate = (newValue) => {
    if (typeof onChange == "function") {
      const formattedDate = newValue?.format(format);
      onChange({
        target: {
          name: name,
          value: formattedDate,
        },
      });
    }

    if (typeof onChangeValue == "function") {
      const formattedDate = newValue?.format(format);
      onChangeValue(formattedDate);
    }
  };

  return (
    <TimePicker
      open={open}
      value={dateValue}
      onAccept={onChangeDate}
      minTime={minTime}
      maxTime={maxTime}
      disabled={disabled}
      onClose={() => setOpen(false)}
      format={format}
      timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
      closeOnSelect={false}
      slotProps={{
        popper: {
          sx: {
            "& .MuiList-root": {
              scrollbarWidth: "thin",
            },
          },
        },
        textField: {
          error: false,
          onClick: () => setOpen(true),
          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                <ClockIcon />
              </InputAdornment>
            ),
          },
        },
        openPickerIcon: {
          onClick: () => {
            setOpen(true);
          },
        },
      }}
      sx={{
        "& .MuiInputBase-root": {
          height: small ? "42px" : "56px",
          "& input": {
            color: value ? "#111" : "#8e8e8e",
          },
          "& fieldset": {
            borderWidth: 1,
            borderColor: "#CBCAD7",
            borderRadius: "0.375rem",
          },
          "&.Mui-focused fieldset": {
            borderWidth: 1,
            borderColor: "#CBCAD7",
            borderRadius: "0.375rem",
          },
          "&:hover fieldset": {
            borderWidth: 1,
            borderColor: "#CBCAD7",
            borderRadius: "0.375rem",
          },
        },
        width: "100%",
      }}
    />
  );
};

export default TimeSelector;
